import { LabelValueSet } from "../utility/LabelValueSet";

const LifeStatusType = Symbol();

export class LifeStatus extends LabelValueSet  {
    [LifeStatusType]: any;

    static fromNothing(): LifeStatus {
        return 終日独居;
    }
}

const 終日独居 = new LifeStatus("一人暮らし", "終日独居");
const 日中独居 = new LifeStatus("日中だけ一人（家族は仕事等で不在の時間がある）", "日中独居");
const 同居 = new LifeStatus("同居", "同居");


const mapValueToItem: { [key: string] : LifeStatus} = {
    "終日独居": 終日独居,
    "日中独居": 日中独居,
    "同居": 同居,
};

export const lifeStatusList: LifeStatus[] = [
    終日独居,
    日中独居,
    同居,
];

export const getLifeStatusFromValue = (value: string): LifeStatus | undefined => {
    return mapValueToItem[value];
};
